import { Component } from '@angular/core';
import { SkeletonBlock } from '../../../../../shared/components/skeleton/skeleton-block';

/** Line-row count matching Skeleton Screens.dc.html `skelService` Estimated Costs rail. */
const COST_LINE_PLACEHOLDER_COUNT = 6;

/**
 * Estimated Costs rail skeleton. Swaps with the delivery matrix from the same rate call.
 */
@Component({
  selector: 'app-estimated-costs-skeleton',
  imports: [SkeletonBlock],
  templateUrl: './estimated-costs-skeleton.html',
  styleUrl: './estimated-costs-skeleton.scss',
})
export class EstimatedCostsSkeleton {
  protected readonly linePlaceholders = Array.from(
    { length: COST_LINE_PLACEHOLDER_COUNT },
    (_, index) => index,
  );
}
